/**
 * Stops a thread's answer without pausing its message queue (ADMIN-212), for "Send now" on a
 * queued message. assistant-ui's own cancel (the stop button) pauses the queue so the queued
 * messages wait; and its steer only interrupts when the queue's driver can cancel, which the AI
 * SDK runtime's doesn't. Stopping the chat itself ends the run like a finished answer, so the
 * queue sends its next message, the one just moved to the front.
 */

const stoppers = new Map<string, () => unknown>();

/** Called by each thread's runtime hook (use-agent-thread.ts); returns the unregister. */
export function registerStopper(threadId: string, stop: () => unknown): () => void {
  stoppers.set(threadId, stop);
  return () => {
    if (stoppers.get(threadId) === stop) stoppers.delete(threadId);
  };
}

/** Stops the thread's answer; false when no thread by that id is open. */
export function stopAnswer(threadId: string): boolean {
  const stop = stoppers.get(threadId);
  if (!stop) return false;
  void stop();
  return true;
}
